import _ from 'lodash';

export default function VideoEmbedPlugin({ decorator = _.identity, VideoEmbed }) {
  const DecoratedVideoEmbed = decorator(VideoEmbed);
  return {
    blockRendererFn: (block, { getEditorState, getReadOnly }) => {
      if (block.getType() === 'atomic') {
        const contentState = getEditorState().getCurrentContent();
        const entityKey = block.getEntityAt(0);
        if (entityKey && contentState.getEntity(entityKey).getType() === 'VIDEO-EMBED') {
          return {
            component: DecoratedVideoEmbed,
            editable: false,
            props: {
              readOnly: Boolean(getReadOnly()),
            },
          };
        }
      }
    },
  };
}



// WEBPACK FOOTER //
// ./app/components/text-editor/plugins/video-embed.js